import React from 'react';
import { Box, Button, InputAdornment, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import './index.scss';
import BaseInput from '../../component/form/base-input.component';

/**
 * 搜索组件
 */
class SearchComponent extends React.PureComponent<Props, State> {
    public state: State = {
        searchItemKey: '',
        inputSearchValue: ''
    }

    componentDidMount() {
        const selectAction = this.props.selectAction;
        this.setState({
            searchItemKey: selectAction?.[0]?.value || ''
        })
    }

    render(): React.ReactNode {
        const { selectAction } = this.props;
        const { searchItemKey, inputSearchValue } = this.state;
        return (
            <div className='rbp-search-box'>
                <Box>
                    <BaseInput
                        select
                        fullWidth={false}
                        items={selectAction.map((item) => { return { value: item.value, label: item.text } })}
                        onChange={(e) => {
                            this.setState({
                                searchItemKey: (e?.target?.value || '') as string
                            });
                        }}
                        value={searchItemKey}
                    />
                </Box>
                <TextField
                    className='searchInput'
                    id='standard-end-adornment'
                    size={'small'}
                    onChange={(event: { target: { value: string; }; }) => {
                        this.setState({
                            inputSearchValue: event.target.value
                        })
                    }}
                    value={inputSearchValue}
                    onKeyDown={() => {
                        // this.props.onSearch(searchItemKey, inputSearchValue);
                    }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end'>
                                <Button
                                    className='searchIconBtn'
                                    onClick={() => {
                                        this.props.onSearch(searchItemKey, inputSearchValue)
                                    }}
                                >
                                    <Search />
                                </Button>
                            </InputAdornment>
                        )
                    }}
                />
            </div>
        )
    }
}

export default SearchComponent;

// *****************
// TYPE
// *****************

type Props = {
    selectAction: Array<any>;
    onSearch: (type: string, value: string) => void;
};

type State = {
    searchItemKey: string;
    inputSearchValue: string;
};